<div id="discounts-modal">
  <div class="modal-header">
    <h4 class="bolt-body-copy-lg" id="discountInfoModalHeader">
      Discount information
    </h4>
  </div>
  <div class="inner-body">
    <div class="bolt-container-fluid">
      <bolt-accordion-group header="" class="discounts-group">
        @for (product of products; track product.type) {
          <div>
            @if (product.type !== 'PersonalUmbrella') {
              <bolt-accordion
                class="discount-group"
                header="{{ product.name }} discounts "
                >
                @for (helptext of discountInformation[product.type]; track helptext.helpText) {
                  <ul>
                    <li>
                      <strong>{{ helptext.discountName }}</strong> –
                      {{ helptext.helpText }}
                    </li>
                  </ul>
                }
                <br>
                  @if (product.type === 'PersonalAuto') {
                    <p>
                      {{ agentDisclaimer }}
                    </p>
                  }
                </bolt-accordion>
              }
              @if (product.type !== 'PersonalUmbrella') {
                <hr />
              }
            </div>
          }
          <div>
            <bolt-accordion
              class="discount-group"
              header="Policy level discounts"
              >
              @for (helptext of discountInformation['PolicyLevel']; track helptext.helpText) {
                <ul>
                  <li>
                    <strong>{{ helptext.discountName }}</strong> –
                    {{ helptext.helpText }}
                  </li>
                </ul>
              }
            </bolt-accordion>
            <hr />
          </div>
        </bolt-accordion-group>
      </div>
    </div>
    <div class="modal-footer">
      <bolt-button-bar>
        <bolt-button slot="back" type="solid" (click)="closeModal()"
          >Close</bolt-button
          >
        </bolt-button-bar>
      </div>
    </div>
